import { attributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import LayoutNode, { getNodeStyleAttributeValue, setNodeStyleAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import WebDesigner from "../WebDesigner";

export function FixedHeightWarning({ node, typename }: { node: LayoutNode, typename: string }) {

    let capitalize =typename.charAt(0).toUpperCase() + typename.slice(1);

    return <div
        className="w-full center-all"

        

        style={{overflow:"hidden", gap: "24px", pointerEvents: "all", position: "absolute", top: "0", left: "0", backgroundColor: "#FFE1B2", color: "#8C5704", padding: "16px", zIndex: 1000, fontFamily: "proxima-nova", fontSize: "16px" }}
    ><svg xmlns="http://www.w3.org/2000/svg" className="no-shrink" viewBox="0 0 512 512" fill="currentColor" height={"2em"}><path d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480L40 480c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z" /></svg>

        <div style={{ maxWidth: "50%" }}>{`This component is inside a ${capitalize} with a set height which may result in it being partially cut off.`}</div>
        <button
            className="invisible-button hollow-btn dark"

            onClick={() => FindClosestFixedHeightContainer(node, true)}
        >
            {`Clear ${capitalize} Height`}
        </button></div>

}

export function FindClosestFixedHeightContainer(node: LayoutNode, applyFix: boolean = false): LayoutNode | null {

    const isFixedHeight = (heightVal: string): boolean => {
        return heightVal.length > 0 && heightVal != "auto" && heightVal != "Auto";
    }

    let parent = node.parent;
    let saveState = false;
    while (parent) {
        let mobile = isFixedHeight(getNodeStyleAttributeValue(parent, ScreenSize.Mobile, attributeTypes.height, ""));
        let tablet = isFixedHeight(getNodeStyleAttributeValue(parent, ScreenSize.Tablet, attributeTypes.height, ""));
        let desktop = isFixedHeight(getNodeStyleAttributeValue(parent, ScreenSize.Desktop, attributeTypes.height, ""));

        if (applyFix) {
            let applied = false;
            if (mobile) {
                setNodeStyleAttributeValue(parent, ScreenSize.Mobile, attributeTypes.height, "Auto");
                applied = true;
            }
            if (tablet) {
                setNodeStyleAttributeValue(parent, ScreenSize.Tablet, attributeTypes.height, "Auto");
                applied = true;
            }
            if (desktop) {
                setNodeStyleAttributeValue(parent, ScreenSize.Desktop, attributeTypes.height, "");
                applied = true;
            }

            if (applied) {
                saveState = true;
                parent.forceUpdate && parent.forceUpdate();
            }

        }
        else if (mobile || tablet || desktop) {
            return parent;
        }


        parent = parent.parent;
    }
    if (saveState) {
        node.forceUpdate && node.forceUpdate();
        let designer: WebDesigner | undefined = (window as any).designer;
        if (designer) {
            designer.saveUndoState();
        }
    }

    return null;
}